const Localizations: { [key: string]: string } = {
  'en-US': 'English',
};

export default Localizations;
